export default __webpack_public_path__ + "static/media/icon-email.34807f42.svg";